import * as Yup from "yup";
import { RIDER_CLIENT_ID, TATWEER_CLIENT_ID, TATWEER_FOLLOW_UP_REQUEST } from "./constants";

const TARGET_CLIENT_ID = "69afdc065323c68fd76cdabf";

export const getDealValidationSchema = (userId) => {
  const isTargetClient = userId === TARGET_CLIENT_ID;

  // The rider client's form only collects rider fields, so it has its own schema
  // rather than layering extra rules on the standard lead schema.
  if (userId === RIDER_CLIENT_ID) {
    return Yup.object({
      riderId: Yup.string().trim().required("Rider ID is required"),
      riderName: Yup.string().trim().required("Rider name is required"),
      riderPlatform: Yup.string().trim().required("Platform is required"),
      mobile: Yup.string()
        .transform((v) => (v ? v.replace(/\s+/g, "") : v))
        .nullable(),
    });
  }

  if (userId === TATWEER_CLIENT_ID) {
    return Yup.object({
      dealName: Yup.string().trim().required("Customer name is required"),
      mobile: Yup.string()
        .transform((v) => (v ? v.replace(/\s+/g, "") : v))
        .required("Mobile number is required"),
      area: Yup.string().trim().required("Area / community is required"),
      serviceCategory: Yup.string().required("Service category is required"),
      requestType: Yup.string().required("Request type is required"),
      description: Yup.string().trim().required("Issue description is required"),
      existingTicketId: Yup.string().when("requestType", {
        is: TATWEER_FOLLOW_UP_REQUEST,
        then: (s) => s.trim().required("Ticket ID is required for follow-ups"),
        otherwise: (s) => s.nullable(),
      }),
      amount: Yup.number()
        .transform((v, orig) => (orig === "" ? undefined : v))
        .typeError("Charges must be a number")
        .min(0, "Charges cannot be negative")
        .nullable(),
    });
  }

  return Yup.object({
    mobile: Yup.string()
      .transform((v) => (v ? v.replace(/\s+/g, "") : v))
      .nullable(),
    email: Yup.string().email("Invalid email address").nullable(),
    machineNumber: isTargetClient
      ? Yup.string().required("Machine ID is required")
      : Yup.string().nullable(),
    complaintStatus: isTargetClient
      ? Yup.string().required("Status is required")
      : Yup.string().nullable(),
  });
};

// Keep backward-compat alias (uses no extra validation)
export const dealValidationSchema = getDealValidationSchema("");

export const stageValidationSchema = Yup.object({
  name: Yup.string()
    .required("Stage name is required")
    .min(2, "Stage name must be at least 2 characters")
    .max(50, "Stage name must be less than 50 characters"),
  color: Yup.string()
    .required("Color is required")
    .matches(/^#[0-9A-F]{6}$/i, "Must be a valid hex color"),
});

export const companyValidationSchema = Yup.object({
  name: Yup.string()
    .required("Company name is required")
    .min(2, "Company name must be at least 2 characters")
    .max(100, "Company name must be less than 100 characters"),
  phone: Yup.string().matches(
    /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
    "Invalid phone number format"
  ),
  website: Yup.string().url("Invalid URL format"),
});

export const contactValidationSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email"),
  phone: Yup.string().matches(/^[0-9+\-\s()]+$/, "Invalid phone number"),
});
